<h1>{{ 'notFound.title' | transloco }}</h1>
<p>{{ 'notFound.message' | transloco }}</p>
<a href="/">{{ 'notFound.backHome' | transloco }}</a>
